import React from 'react';
import ReactGA from 'react-ga4';

const Content = () => {
  return (
    <>
      <div className="popup-content-title">
        <h3>Clyde North - Tuckers Road Recycled Water Main</h3>
      </div>
      <div className="popup-content-source">
        <p className="bold">
        This project is to design and install around 2.5 kilometres of recycled water main along Tuckers Road, Clyde North, to meet the growing demands of the Clyde area.  
        </p>
        
        <p>
          For more information, click{' '}
          <a
            href="https://southeastwater.com.au/faults-and-works/works/planned-works/tuckersrd/"
            target="_blank"
            rel="noreferrer"
            onClick={() => {
              ReactGA.event({
                category: 'Map - Major Projects (purple)',
                action: '<a href> link',
                label:
                  'MORE INFO: Tuckers Road Recycled Water Main Project',
              });
            }}
          >
            here
          </a>{' '}
          or contact the project team at{' '}
          <a href="tel:1800403833">1800 403 833</a> |{' '}
          <a
            href="mailto:engagement@sew.com.au"
            target="_blank"
            rel="noreferrer"
            onClick={() => {
              ReactGA.event({
                category: 'Map - Major Projects (purple)',
                action: '<a href> link',
                label:
                  'MAIL TO: ENGAGEMENT@SEW.COM.AU - Tuckers Road Recycled Water Main Project',
              });
            }}
          >
            engagement@sew.com.au
          </a>
        </p>
      </div>
    </>
  );
};

export default Content;
